import { forwardRef, ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import { Typography } from '@scale/scaleui';
import Kbd from 'react-scale/components/design-system/Kbd';

type SearchResultsListProps = {
  className?: string;
  children: ReactNode;
};

export const SearchResultsList = forwardRef<HTMLDivElement, SearchResultsListProps>(
  ({ className, children }, forwardedListRef) => {
    return (
      <>
        <div
          className={twMerge(
            'overflow-auto divide-y divide-neutral-200 border-t border-t-neutral-200',
            className,
          )}
          ref={forwardedListRef}
        >
          {children}
        </div>
        <div className="flex flex-shrink-0 gap-1 items-center px-3 py-2 bg-neutral-50 border-t border-t-neutral-200 shadow">
          <div className="space-y-1">
            <div className="flex items-center">
              <Typography.Overline3>{'Press'}</Typography.Overline3>
              <Kbd>ArrowDown</Kbd>
              <Typography.Overline3>{'and'}</Typography.Overline3>
              <Kbd>ArrowUp</Kbd>
              <Typography.Overline3>{'to navigate the list,'}</Typography.Overline3>
              <Kbd>Enter</Kbd>
              <Typography.Overline3>{','}</Typography.Overline3>
              <Kbd>Shift + Enter</Kbd>
              <Typography.Overline3>{'or'}</Typography.Overline3>
              <Kbd>Cmd + Enter</Kbd>
              <Typography.Overline3>{'to open the selected result.'}</Typography.Overline3>
            </div>
            <div className="flex items-center">
              <Typography.Overline3>{'Press'}</Typography.Overline3>
              <Kbd>Cmd + K</Kbd>
              <Typography.Overline3>{'to open the search and'}</Typography.Overline3>
              <Kbd>Escape</Kbd>
              <Typography.Overline3>{'to close it.'}</Typography.Overline3>
            </div>
          </div>
          <Typography.Overline3 className="uppercase ml-auto">
            {'Made with 💖 by the Gen AI team'}
          </Typography.Overline3>
        </div>
      </>
    );
  },
);
